import React from 'react'
import { Deal } from '../models/shared/Deal';
import { useText } from '../context/TextContext';
import { DEFAULT_TAGS, TagDefinition } from '../models/shared/TagDefinition';
import { FormCheck, FormControl } from 'react-bootstrap';
import Tags from './Tags';
import { useOrganization } from '../context/OrganizationContext';
import { useSaveToast } from '../context/SaveToastContext';
import { toast } from 'react-toastify';
import { useFirestore } from 'reactfire';
import { doc, updateDoc } from 'firebase/firestore';
import { Organization } from '../models/shared/Organization';
import { COLLECTIONS } from '../utils/shared/constants';
import DealModalSection from './DealModalSection';

interface Props {
    deal: Deal;
    onDealUpdate: (update: Partial<Deal>) => void;
    className?: string;
    readOnly?: boolean;
}

let timeout: NodeJS.Timeout | null = null;

export default function TagsManagement(props: Props) {
    const text = useText();
    const { orgId, organization } = useOrganization();
    const [allTags, setAllTags] = React.useState(organization.tags || DEFAULT_TAGS);
    const { markSaved, startSaving } = useSaveToast();
    const firestore = useFirestore();

    const toggleTag = (tagId: string) => {
        const tags = props.deal.tags || [];
        if (tags.includes(tagId)) {
            props.onDealUpdate({
                tags: tags.filter(t => t !== tagId)
            });
        } else {
            props.onDealUpdate({
                tags: [...tags, tagId]
            });
        }
    }

    const handleTagDefinitionChange = (tagId: string, update: Partial<TagDefinition>) => {
        const newTags = allTags.map(tag => {
            if (tag.id === tagId) {
                return { ...tag, ...update };
            }
            return tag;
        });

        setAllTags(newTags);

        if (timeout) {
            clearTimeout(timeout);
        }
        timeout = setTimeout(async () => {
            try {
                const id = startSaving();

                const orgRef = doc(firestore, `${COLLECTIONS.ORGANIZATIONS}/${orgId}`);
                const update: Partial<Organization> = {
                    tags: newTags
                }
                await updateDoc(orgRef, update);

                markSaved(id);
            } catch (error) {
                console.log('Error updating deal', error)
                toast.error(text.defaultError)
            }
        }, 1000);

    }


    return (
        <DealModalSection title={text.tags} alwaysVisibleChildren={<Tags className="mb-2" deal={props.deal} />}>

            <div className='d-flex flex-column gap-2'
            >
                {allTags.map(tag => {
                    const isTagged = props.deal.tags?.includes(tag.id) || false;
                    return <div key={tag.id} className='d-flex align-items-center gap-2'>
                        <FormCheck

                            type='checkbox'
                            checked={isTagged}
                            onChange={() => toggleTag(tag.id)}
                            disabled={props.readOnly}
                        />
                        <FormControl
                            type='color'
                            value={tag.color}
                            className='flex-1'
                            disabled={props.readOnly}
                            onChange={e => handleTagDefinitionChange(tag.id, { color: e.target.value })}
                        />
                        <FormControl
                            value={tag.text || ''}
                            className='flex-1'
                            readOnly={props.readOnly}
                            onChange={e => handleTagDefinitionChange(tag.id, { text: e.target.value })}
                        />
                    </div>
                })}
            </div>
        </DealModalSection>
    )
}
